var DealsApplication, PaginatedDealsBuilder,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsApplication = require('../application');

module.exports = PaginatedDealsBuilder = (function() {
  function PaginatedDealsBuilder(arg) {
    this.omitSearch = (arg != null ? arg : {}).omitSearch;
    this.triggerFetchSuccess = bind(this.triggerFetchSuccess, this);
    this.triggerFetchError = bind(this.triggerFetchError, this);
    this.events = _.clone(Backbone.Events);
    this.search = new DealsApplication(this._searchOptions());
    this.search.on('error', this.triggerFetchError);
    this.search.on('success', this.triggerFetchSuccess);
  }

  PaginatedDealsBuilder.prototype._searchOptions = function() {
    if (Groupon.onNoDealsPage) {
      return {
        unfiltered: true
      };
    } else {
      return _.omitUndefined({
        omitSearch: this.omitSearch
      });
    }
  };

  PaginatedDealsBuilder.prototype.triggerFetchError = function() {
    this.events.trigger('fetchError');
    return this.events.stopListening();
  };

  PaginatedDealsBuilder.prototype.triggerFetchSuccess = function() {
    return $((function(_this) {
      return function() {
        _this.events.trigger('fetchSuccess', _this.search);
        return _this.events.stopListening();
      };
    })(this));
  };

  PaginatedDealsBuilder.prototype.on = function() {
    var ref;
    return (ref = this.events).on.apply(ref, arguments);
  };

  return PaginatedDealsBuilder;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9kZWFscy9mcm9udGVuZC9oZWxwZXJzL3BhZ2luYXRlZF9kZWFsc19idWlsZGVyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2Fic2hhcm1hL25hcGlzdHJhbm8vYnVpbGQvMTQ4NjY3NTYyNDI3NC03NDM3L3N0YWdpbmctcGVyZi0yMDE3LjAyLjA5XzAwLjM1L2dvb2RzL21vZHVsZXMvZGVhbHMvZnJvbnRlbmQvaGVscGVycy9wYWdpbmF0ZWRfZGVhbHNfYnVpbGRlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSx1Q0FBQTtFQUFBOztBQUFBLGdCQUFBLEdBQW1CLE9BQUEsQ0FBUSxnQkFBUjs7QUFFbkIsTUFBTSxDQUFDLE9BQVAsR0FBdUI7RUFDUiwrQkFBQyxHQUFEO0lBQUUsSUFBQyxDQUFBLDRCQUFGLE1BQWdCLElBQWQ7OztJQUNkLElBQUMsQ0FBQSxNQUFELEdBQVUsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxRQUFRLENBQUMsTUFBakI7SUFFVixJQUFDLENBQUEsTUFBRCxHQUFjLElBQUEsZ0JBQUEsQ0FBaUIsSUFBQyxDQUFBLGNBQUQsQ0FBQSxDQUFqQjtJQUVkLElBQUMsQ0FBQSxNQUFNLENBQUMsRUFBUixDQUFXLE9BQVgsRUFBb0IsSUFBQyxDQUFBLGlCQUFyQjtJQUNBLElBQUMsQ0FBQSxNQUFNLENBQUMsRUFBUixDQUFXLFNBQVgsRUFBc0IsSUFBQyxDQUFBLG1CQUF2QjtFQU5XOztrQ0FRYixjQUFBLEdBQWdCLFNBQUE7SUFDZCxJQUFHLE9BQU8sQ0FBQyxhQUFYO2FBQ0U7UUFBQSxVQUFBLEVBQVksSUFBWjtRQURGO0tBQUEsTUFBQTthQUdFLENBQUMsQ0FBQyxhQUFGLENBQ0U7UUFBQSxVQUFBLEVBQVksSUFBQyxDQUFBLFVBQWI7T0FERixFQUhGOztFQURjOztrQ0FPaEIsaUJBQUEsR0FBbUIsU0FBQTtJQUNqQixJQUFDLENBQUEsTUFBTSxDQUFDLE9BQVIsQ0FBZ0IsWUFBaEI7V0FDQSxJQUFDLENBQUEsTUFBTSxDQUFDLGFBQVIsQ0FBQTtFQUZpQjs7a0NBSW5CLG1CQUFBLEdBQXFCLFNBQUE7V0FDbkIsQ0FBQSxDQUFFLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQTtRQUNBLEtBQUMsQ0FBQSxNQUFNLENBQUMsT0FBUixDQUFnQixjQUFoQixFQUFnQyxLQUFDLENBQUEsTUFBakM7ZUFDQSxLQUFDLENBQUEsTUFBTSxDQUFDLGFBQVIsQ0FBQTtNQUZBO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFGO0VBRG1COztrQ0FLckIsRUFBQSxHQUFJLFNBQUE7QUFDRixRQUFBO1dBQUEsT0FBQSxJQUFDLENBQUEsTUFBRCxDQUFPLENBQUMsRUFBUixZQUFXLFNBQVg7RUFERSJ9
